import { render, staticRenderFns } from "./ActivateAccountConfirmData.vue?vue&type=template&id=86f2cee6&"
import script from "./ActivateAccountConfirmData.vue?vue&type=script&lang=js&"
export * from "./ActivateAccountConfirmData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports